import { Flex, Paper, Text, Button } from "@mantine/core";
import { IconFileText, IconDownload } from "@tabler/icons-react";
import { getFileUrl } from "@/shared/utils/useFileUrl";

interface DocumentsTabProps {
  company: any;
  isMatchedView?: boolean;
}

export default function DocumentsTab({ company, isMatchedView = false }: DocumentsTabProps) {
  const documents = company.documents || [];

  const handleViewDocument = async (document: any) => {
    if (!document?.id) {
      console.error("Document ID not found");
      return;
    }

    try {
      const url = await getFileUrl(document.id, true);
      if (url) {
        // Create invisible link and click it to force download if needed,
        // or just window.open since we set Content-Disposition
        window.open(url, "_blank");
      }
    } catch (err) {
      console.error("Error downloading document:", err);
    }
  };

  return (
    <Flex direction="column" gap="md">
      {documents.length === 0 ? (
        <Paper p="xl" radius="lg" style={{ border: "1px solid #E5E7EB" }}>
          <Text c="slate.5" ta="center">
            No documents available
          </Text>
        </Paper>
      ) : (
        documents.map((document: any, index: number) => (
          <Paper
            key={document.id}
            p={{ base: "md", sm: "lg" }}
            radius="lg"
            bg="#F4F4F533"
            style={{ border: "1px solid #E5E7EB" }}
          >
            <Flex align="center" justify="space-between" gap="md">
              <Flex align="center" gap="md" style={{ flex: 1 }}>
                <Flex
                  w={{ base: 36, sm: 40 }}
                  h={{ base: 36, sm: 40 }}
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#F9FAFB",
                    flexShrink: 0,
                  }}
                  align="center"
                  justify="center"
                >
                  <IconFileText size={20} color="#6B7280" />
                </Flex>

                <Flex direction="column" style={{ flex: 1 }}>
                  <Text fz={{ base: "sm", sm: "md" }} fw={500} mb={2}>
                    {isMatchedView ? (document.title || document.name || "Untitled Document") : `Document ${index + 1}`}
                  </Text>
                  <Text fz={{ base: "xs", sm: "sm" }} c="slate.5">
                    {document.createdAt || document.uploadedAt
                      ? `Uploaded on ${new Date(document.createdAt || document.uploadedAt).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}`
                      : document.subtitle || document.description || ""}
                  </Text>
                </Flex>
              </Flex>

              {isMatchedView && (
                <Button
                  variant="subtle"
                  color="primary.7"
                  size="sm"
                  leftSection={<IconDownload size={16} />}
                  onClick={() => handleViewDocument(document)}
                >
                  Download
                </Button>
              )}
            </Flex>
          </Paper>
        ))
      )}
    </Flex>
  );
}
